module.exports = __webpack_public_path__ + "img/271_1_kale-hakkimizda.3f71ba56.jpg";